import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";

//components
import ContentWrapper from "../../../containers/ContentWrapper";
import SelectShotTable from "./Table/SelectShotTable";

class SelectShotsStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allowNext: false,
      selected: ""
    };
  }

  static getDerivedStateFromProps(props, state) {
    // let shots = props.shots.filter(item =>item.selected)
    let shots = props.shots.filter(item => item.scene.toUpperCase().includes(state.selected.toUpperCase()));
    let shotsfinal = shots.filter(item => item.selected);
    console.log(shotsfinal.length);
    if (shotsfinal.length > 0) {
      return { allowNext: true };
    } else return null;
  }

  componentDidMount() {
    // console.log("componentDidMount")
    // this.props.getShots();
  }

  handleSelectedShots = shot => {
    let state = this.state.shots;
    state.concat(shot);
    this.setState({ shot: state });
    console.log(this.state.shot);
  };
  handleFilter = e => {
    this.props.handleFilter(e);
    this.setState({
      selected: e
    });
  };

  render() {
    return (
      <ContentWrapper hasPadding>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button variant="contained" disabled={true}>
            Back
          </Button>

          <Button variant="contained" color="primary" onClick={this.props.proceedToReview} disabled={!this.props.selectedShots.length > 0}>
            Next
          </Button>
        </div>
        <Paper style={{ marginTop: 30 }}>
          {/* <div style={{ padding: 24 }}>
            <Typography variant="subtitle2">
              Please select the shots that you want to add to the shoot.
            </Typography>
          </div> */}
          <SelectShotTable {...this.props} handleFilterValue={this.handleFilter} />
        </Paper>
      </ContentWrapper>
    );
  }
}

export default SelectShotsStep;
